import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-product-card-promotions-banner',
  templateUrl: './product-card-promotions-banner.component.html',
  styleUrls: ['./product-card-promotions-banner.component.scss'],
})
export class ProductCardPromotionsBannerComponent {
  @Input() offerBenefitDesc: string;
  @Input() productNumber: number;

  @Output() bannerClickEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  bannerClick() {
    this.bannerClickEmitter.emit();
  }
}
